import { Text, VisuallyHidden } from '@customerio/pluma-components/react';
import plur from 'plur';
import type { TextProps } from '@customerio/pluma-components/react';

interface DurationProps extends Omit<TextProps, 'children'> {
  seconds: number;
}

export function Duration({ seconds, size = 'xs', color = 'secondary', ...textProps }: DurationProps) {
  if (Number.isNaN(seconds) || seconds < 0) {
    return null;
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

  const voiceOverParts: string[] = [];
  if (minutes > 0) {
    voiceOverParts.push(`${minutes} ${plur('minute', minutes)}`);
  }
  if (remainingSeconds > 0) {
    voiceOverParts.push(`${remainingSeconds} ${plur('second', remainingSeconds)}`);
  }
  const voiceOver = voiceOverParts.length > 0 ? voiceOverParts.join(' and ') : '0 seconds';

  return (
    <>
      <Text size={size} color={color} aria-hidden="true" {...textProps}>
        {minutes}:{formattedSeconds}
      </Text>
      <VisuallyHidden>This video is {voiceOver} long</VisuallyHidden>
    </>
  );
}
